import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, finalize, filter, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';
import { MsalService } from '@azure/msal-angular';


@Injectable({
  providedIn: 'root'
})

export class ProfileService {

  env = environment;
  private profileRequest$: Observable<any> | null = null;
  private cellVerificationDoneSubject = new BehaviorSubject<boolean>(
    sessionStorage.getItem('cellVerificationDone') === 'true'
  );
  cellVerificationDone$ = this.cellVerificationDoneSubject.asObservable();

  constructor(private readonly http: HttpClient, private readonly msalService: MsalService, private readonly userService: UserService) { }
  userProfile() {
    if (!this.profileRequest$) {
      this.profileRequest$ = this.http.post(this.env.webApiUrl + 'api/user/Profile', null).pipe(
        finalize(() => { this.profileRequest$ = null; }),
        shareReplay(1)
      );
    }
    return this.profileRequest$;
  }

  updateProfile(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/user/UpdateUserProfile', data);
  }
  verifyCellNumber(data:any){
    return this.http.get(this.env.webApiUrl + 'api/user/VerifyIfPhoneNumberExists?newPhoneNumber='+data );
  }
  confirmCellVerification() {
    const isNewLoginSession = sessionStorage.getItem('pendingLoginProcessing') === 'true';
    sessionStorage.removeItem('pendingLoginProcessing');
    return this.http.post(
      this.env.webApiUrl + 'api/user/ConfirmCellVerification?isNewLoginSession=' + isNewLoginSession,
      null
    );
  }

  // update the cellphone number parked by the MFA update, after basic info or security questions pass.
  updateVerifiedMfaPhoneNumber() {
    return this.http.post(this.env.webApiUrl + 'api/user/UpdateVerifiedMfaPhoneNumber', null);
  }

  markCellVerificationDone() {
    sessionStorage.setItem('cellVerificationDone', 'true');
    this.cellVerificationDoneSubject.next(true);
  }

  waitForCellVerification(): Observable<boolean> {
    return this.cellVerificationDone$.pipe(filter(done => done), take(1));
  }

  showGrossIncomePopupAfterVerification(getGrossIncome: () => any, openModal: () => void): void {
    if (getGrossIncome() == undefined || getGrossIncome() == null || getGrossIncome() == 0) {
      this.waitForCellVerification().subscribe(() => {
        if (getGrossIncome() != undefined && getGrossIncome() != null && getGrossIncome() != 0) {
          return;
        }
        setTimeout(() => openModal(), 1000);
      });
    }
  }
  updatePhoneNumber(data:any){
    let token: any = '';

    const activeAccount = this.msalService.instance.getActiveAccount();
    if (activeAccount) {
      token = this.msalService.acquireTokenSilent({
        scopes: ['user.read'],
        account: activeAccount,
      });
    }

    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(this.env.webApiUrl + 'api/user/UpdatePhoneNumber', data, { headers });
  }

  public sendLoginSignal() {
    const signalName = 'login-successful';
    const sessionKey = `signal_${signalName}_sent`;
    const signalSent = sessionStorage.getItem(sessionKey);

    if (signalSent === 'true') {
      return;
    }

    this.userService.sendSignal(JSON.stringify(signalName)).subscribe({
      next: (data: any) => {
        sessionStorage.setItem(sessionKey, 'true');
      },
      error: (err: HttpErrorResponse) => {
        sessionStorage.setItem(sessionKey, 'true');
      }
    });
  }

  processLoginDebtCounsellingLms(isNewLoginSession: boolean = false) {
    return this.http.post(
      this.env.webApiUrl + 'api/user/ProcessLoginDebtCounsellingLms?isNewLoginSession=' + isNewLoginSession,
      null
    );
  }
}
